import React from 'react';
import { Link } from 'react-router-dom';

const CTA = () => {
  return (
    <section className="relative">
      {/* Curved top */}
      <div 
        className="absolute top-0 left-0 right-0 h-20 bg-[#faf8f5]"
        style={{ 
          borderBottomLeftRadius: '50% 100%',
          borderBottomRightRadius: '50% 100%'
        }}
      />
      
      <div className="py-24 bg-[#1a1a1a]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-8">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready for Harvest 2025/26?
          </h2>
          <p className="text-gray-300 mb-10 max-w-2xl mx-auto">
            Get in touch with our team to discuss your grain storage and export needs for the upcoming season.
          </p>
          <Link
            to="/contact"
            className="inline-block px-8 py-3 bg-transparent text-yellow-500 font-semibold rounded-md border-2 border-yellow-500 hover:bg-yellow-500 hover:text-gray-900 transition-all duration-300"
          >
            Contact Us Today
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTA;
